module.exports = __webpack_public_path__ + "static/media/floor1_s.0faec96a.jpg";